<div class="lp">
    <div class="lp-item" *ngFor="let p of paysystems"><img src="/images/paysystems/{{p.img}}" [alt]="p.name"></div>
</div>